module.exports = __webpack_public_path__ + "img/ic_download.4edb6653.svg";